module.exports = __webpack_public_path__ + "assets/chase-me-53d5e82da55a80e6b56fec27220bdadb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/chase-me.jpg
// module id = 508
// module chunks = 1